import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackBoardCustomFieldsSidePanelOpened } from "@air/analytics";
import { CustomFieldsPanel, CustomFieldsPanelContent } from "@air/component-custom-fields-panel";
import { memo, useEffect } from "react";
import { useSelector } from "react-redux";
import { PublicBoardHeaderAncestors } from "~/_app/(public-board)/_components/PublicBoardHeaderAncestors";
import { usePublicCustomFieldsPanel } from "~/components/PublicBoard/components/PublicBoardCustomFieldsPanelContent/hooks/usePublicCustomFieldsPanel";
import { useURLBoardIdSelector } from "~/hooks/useURLBoardIdSelector";
import { centralizedBoardTitleSelector } from "~/store/centralizedBoard/selectors";
import { usePublicBoardCustomFieldsData } from "~/swr-hooks/customFields/usePublicBoardCustomFieldsData";
import { PublicBoardPanelCustomFieldDateInput } from "./PublicBoardPanelCustomFieldDateInput";
import { PublicBoardPanelCustomFieldPlainText } from "./PublicBoardPanelCustomFieldPlainText";
import { PublicBoardPanelCustomFieldSelect } from "./PublicBoardPanelCustomFieldSelect";
export const PublicBoardCustomFieldsPanel = /*#__PURE__*/ memo(()=>{
    const boardId = useURLBoardIdSelector();
    const boardTitle = useSelector(centralizedBoardTitleSelector);
    const { trackBoardCustomFieldsSidePanelOpened } = useTrackBoardCustomFieldsSidePanelOpened();
    const { data: customFields } = usePublicBoardCustomFieldsData();
    const { closePanel, isPanelOpen } = usePublicCustomFieldsPanel();
    useEffect(()=>{
        if (isPanelOpen && boardId) {
            trackBoardCustomFieldsSidePanelOpened({
                boardId
            });
        }
    }, [
        boardId,
        isPanelOpen,
        trackBoardCustomFieldsSidePanelOpened
    ]);
    if (!isPanelOpen) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CustomFieldsPanel, {
        breadcrumbs: /*#__PURE__*/ _jsx(PublicBoardHeaderAncestors, {}),
        onClose: closePanel,
        title: boardTitle,
        children: /*#__PURE__*/ _jsx(CustomFieldsPanelContent, {
            fields: customFields === null || customFields === void 0 ? void 0 : customFields.data,
            SelectCustomField: PublicBoardPanelCustomFieldSelect,
            DateCustomField: PublicBoardPanelCustomFieldDateInput,
            PlainTextCustomField: PublicBoardPanelCustomFieldPlainText
        })
    });
});
PublicBoardCustomFieldsPanel.displayName = "PublicBoardCustomFieldsPanel";
